const toSnake = (string: string): string => {
  return string.replace(/[A-Z]/g, (letter, index) => {
    return index === 0 ? letter.toLowerCase() : `_${letter.toLowerCase()}`;
  });
};

export const toSnakeCase = <T>(obj: unknown): T => {
  if (obj === null || typeof obj !== 'object') {
    return obj as T;
  }

  if (Array.isArray(obj)) {
    const len = obj.length;
    const arr = new Array(len);

    for (let i = 0; i < len; i++) {
      arr[i] = toSnakeCase(obj[i]);
    }

    return arr as unknown as T;
  }

  const result: Record<string, unknown> = {};
  const keys = Object.keys(obj as Record<string, unknown>);
  const len = keys.length;

  for (let i = 0; i < len; i++) {
    const key = keys[i];
    result[toSnake(key)] = toSnakeCase((obj as Record<string, unknown>)[key]);
  }

  return result as unknown as T;
};
